var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.status== 6)?_c('span',{staticClass:"fs-600 text-primary fw-700"},[_vm._v("(Settlement date)")]):_c('span',{staticClass:"fs-600 text-primary fw-700"},[_vm._v("(Created date)")])])}
var staticRenderFns = []

export { render, staticRenderFns }